import * as React from 'react';
import {Platform, Text, View} from 'react-native';
import {useSelector} from 'react-redux';

import {holderProfileSelector} from '../../../redux/selectors/profile';
import {useStyles} from '../../hooks/styles';
import {GetHolderProfileCabinetResponsePayload} from '../../models/api';
import {useTheme} from '../../theme';
import {DeviceSize, useDeviceSize} from '../../theme/helpers';
import {ExclamationInCircle} from '../explamationInCircle';

export const cardBlockedNotificationHeight = 36;

const getMessage = (deviceSize: DeviceSize): string => {
  switch (deviceSize) {
    case DeviceSize.desktop:
      return 'Ваша карта заблокирована. Обратитесь в ближайшее отделение для перевыпуска или позвоните в техподдержку.';
    default:
      return 'Ваша карта заблокирована.';
  }
};

export const CardBlockedNotification = () => {
  const theme = useTheme();
  const deviceSize = useDeviceSize();
  const {uscIsBlocked = false} = (useSelector(holderProfileSelector()) || {}) as GetHolderProfileCabinetResponsePayload;

  const styles = useStyles(({platformOnly, mediaOnly, align}) => {
    return {
      container: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: cardBlockedNotificationHeight,
        height: cardBlockedNotificationHeight,
        backgroundColor: theme.color.orange100,
        ...platformOnly('web', mediaOnly(DeviceSize.desktop, {position: 'relative', zIndex: -1})),
      },
      message: {
        ...theme.fonts.bodySmallLight,
        color: theme.color.textColor,
        marginTop: Platform.OS !== 'android' ? align(3) : 0,
        marginLeft: 10,
      },
    };
  });

  return uscIsBlocked ? (
    <View style={styles.container}>
      <ExclamationInCircle backgroundColor={theme.color.orange400} />
      <Text style={styles.message} testID='notification-card-blocked--title'>
        {getMessage(deviceSize)}
      </Text>
    </View>
  ) : null;
};
